import { TilesProps } from '@common/types';
import { useSuspiciousActivityTotalEventQuery } from '@hooks/security';
import { NumberTile } from '@pages/InsightsAndAnalytics/tiles/NumberTile';
import { formatNumberWithSuffix } from '@utils/index';
import { useDualSecurityData, pickSummary } from '@hooks/summary';
import { toSuspiciousActivitySnapshot } from '@hooks/summary/adapters';

export const SuspiciousActivityTotalEvents: React.FC<TilesProps> = ({
  params,
  id,
  classNames,
}) => {
  const parsedParams = JSON.parse(params);
  const { data, isLoading } = useDualSecurityData({
    legacyParams: parsedParams,
    useLegacyQuery: useSuspiciousActivityTotalEventQuery,
    mapSummary: (grouped) =>
      toSuspiciousActivitySnapshot(pickSummary(grouped, 'SuspiciousActivity'), parsedParams.days),
  });

  return (
    <NumberTile
      key={id}
      classNames={
        classNames ? classNames : 'col-span-6 md:col-span-3 xl:col-span-2'
      }
      bottomLabel=""
      percentageLabel=""
      headerTitle={'Suspicious activity: Total events'}
      isLoading={isLoading}
      data={data ? [formatNumberWithSuffix(data.count), data.percentage] : []}
    />
  );
};
